module.exports = __webpack_public_path__ + "static/media/reynaud.cf86ffad.png";